import { render, staticRenderFns } from "./lookAll.vue?vue&type=template&id=8db9a10c&scoped=true"
import script from "./lookAll.vue?vue&type=script&lang=js"
export * from "./lookAll.vue?vue&type=script&lang=js"
import style0 from "./lookAll.vue?vue&type=style&index=0&id=8db9a10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db9a10c",
  null
  
)

export default component.exports